import React from 'react'
import { useIsDesignV2 } from '../../../hooks/useIsDesignV2';

interface FormFieldProps {
    id?: string
    name:string
    onChange: ((e: React.ChangeEvent<any>) => void) & ((values: any) => void);
    checked: boolean
    labelText?: string;
    dataTestid?: string;
  }


const InputCheckbox: React.FC<FormFieldProps> = ({id, name, onChange,checked, labelText, dataTestid}) => {
    const isDesignV2 = useIsDesignV2();
    return (
        <>
            <div className={`checkbox-wrapper form-group pt-2 input-checkbox ${isDesignV2 ? 'input-checkbox-mobile-designv2' : ''}`}>
                <label className='d-flex align-items-center f-s18'>
                    <input type="checkbox"
                        id={id || ""}
                        name={name || ""}
                        onChange={onChange}
                        checked={checked}
                        data-testid={dataTestid}
                         />
                    <span className={`ms-2 font-rale ${isDesignV2 ? 'f-s14' : 'f-s18'}`}> {labelText || ''} </span>
                </label>
            </div>
        </>
    )
}

export default InputCheckbox

